var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addData,
            rules: _vm.rules,
            "label-width": "220px",
            "label-position": "right",
            size: "mini"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "主页上方欢迎语：", prop: "above" } },
            [
              _c("el-input", {
                staticStyle: { width: "380px" },
                attrs: {
                  type: "textarea",
                  rows: "6",
                  placeholder: "请输入主页上方欢迎语"
                },
                model: {
                  value: _vm.addData.above,
                  callback: function($$v) {
                    _vm.$set(_vm.addData, "above", $$v)
                  },
                  expression: "addData.above"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "主页播报内容：", prop: "broadcast" } },
            [
              _c("el-input", {
                staticStyle: { width: "380px" },
                attrs: {
                  type: "textarea",
                  rows: "6",
                  placeholder: "请输入主页播报内容"
                },
                model: {
                  value: _vm.addData.broadcast,
                  callback: function($$v) {
                    _vm.$set(_vm.addData, "broadcast", $$v)
                  },
                  expression: "addData.broadcast"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "主页下方语音指令简要说明：", prop: "below" } },
            [
              _c("el-input", {
                staticStyle: { width: "380px" },
                attrs: {
                  type: "textarea",
                  rows: "6",
                  placeholder: "请输入主页下发语音指令简要说明"
                },
                model: {
                  value: _vm.addData.below,
                  callback: function($$v) {
                    _vm.$set(_vm.addData, "below", $$v)
                  },
                  expression: "addData.below"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "1050px", height: "400px" },
              attrs: { label: "语音指令详细说明（弹窗）：", prop: "detailed" }
            },
            [
              _c(
                "div",
                [
                  _c("Tinymce", {
                    ref: "tinymce",
                    attrs: { height: 300, imagePath: "robot/introduction" },
                    model: {
                      value: _vm.addData.detailed,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "detailed", $$v)
                      },
                      expression: "addData.detailed"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { size: "large" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "160px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.onSubmit }
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _vm.searchData.insId !== ""
                ? _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: { type: "success", icon: "el-icon-back" },
                      on: {
                        click: function() {
                          return this$1.$router.go(-1)
                        }
                      }
                    },
                    [_vm._v("返回")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }